import { deleteEmptyKey } from "."

export function createPoint(BMapGL: Window["BMapGL"], options: { lng: number; lat: number }) {
  const { lng, lat } = options
  return new BMapGL.Point(lng, lat)
}

export function createPixel(BMapGL: Window["BMapGL"], options: { x: number; y: number }) {
  const { x, y } = options
  return new BMapGL.Pixel(x, y)
}

export function createBounds(BMapGL: Window["BMapGL"], options: { sw: { lng: number; lat: number }; ne: { lng: number; lat: number } }) {
  const { sw, ne } = options
  return new BMapGL.Bounds(createPoint(BMapGL, sw), createPoint(BMapGL, ne))
}
export function createSize(BMapGL: Window["BMapGL"], options: { width: number; height: number }) {
  const { width, height } = options
  return new BMapGL.Size(width, height)
}

export function createIcon(
  BMapGL: Window["BMapGL"],
  options: {
    url: string
    size: { width: number; height: number }
    opts?: {
      anchor?: { width: number; height: number }
      imageSize?: { width: number; height: number }
      imageOffset?: { width: number; height: number }
      infoWindowAnchor?: { width: number; height: number }
      printImageUrl?: string
    }
  },
) {
  const { url, size, opts = {} } = options
  const iconOption = {
    anchor: opts.anchor && createSize(BMapGL, opts.anchor),
    imageSize: opts.imageSize && createSize(BMapGL, opts.imageSize),
    imageOffset: opts.imageOffset && createSize(BMapGL, opts.imageOffset),
    infoWindowAnchor: opts.infoWindowAnchor && createSize(BMapGL, opts.infoWindowAnchor),
    printImageUrl: opts.printImageUrl,
  }
  deleteEmptyKey(iconOption)
  return new BMapGL.Icon(url, createSize(BMapGL, size), iconOption)
}

export function createLabel(
  BMapGL: Window["BMapGL"],
  options: {
    content: string
    opts?: { offset?: { width: number; height: number }; position?: { lng: number; lat: number }; enableMassClear?: boolean }
  },
) {
  const { content, opts } = options
  const labelOption = {
    offset: opts?.offset && createSize(BMapGL, opts.offset),
    position: opts?.position && createPoint(BMapGL, opts.position),
    enableMassClear: opts?.enableMassClear,
  }
  deleteEmptyKey(labelOption)
  return new BMapGL.Label(content, labelOption)
}

export function createSymbol(
  BMapGL: Window["BMapGL"],
  options: {
    path: string
    opts: {
      anchor?: { width: number; height: number }
      fillColor?: string
      fillOpacity?: number
      scale?: number
      rotation?: number
      strokeColor?: string
      strokeOpacity?: number
      strokeWeight?: number
    }
  },
) {
  const { path, opts } = options
  const symbolOption = {
    anchor: opts.anchor && createSize(BMapGL, opts.anchor),
    fillColor: opts.fillColor,
    fillOpacity: opts.fillOpacity,
    scale: opts.scale,
    rotation: opts.rotation,
    strokeColor: opts.strokeColor,
    strokeOpacity: opts.strokeOpacity,
    strokeWeight: opts.strokeWeight,
  }
  deleteEmptyKey(symbolOption)
  return new BMapGL.Symbol(window[path] || path, symbolOption)
}

export function createIconSequence(BMapGL: Window["BMapGL"], options: { symbol: any; offset: string; repeat: string; fixedRotation: boolean }) {
  const { symbol, offset, repeat, fixedRotation } = options
  return new BMapGL.IconSequence(symbol && createSymbol(BMapGL, symbol), offset, repeat, fixedRotation)
}

export function createPolygon(
  BMapGL: Window["BMapGL"],
  options: {
    // 点数组，每个点包含经纬度
    path: Array<{ lng: number; lat: number }>
    // 多边形的配置项
    opts?: {
      strokeColor?: string
      fillColor?: string
      strokeWeight?: number
      strokeOpacity?: number
      fillOpacity?: number
      enableMassClear?: boolean
      [key: string]: any
    }
  },
) {
  const { path, opts } = options
  // 将传入的坐标数组转换为 BMapGL.Point 实例数组
  const points = path.map(coordinate => createPoint(BMapGL, coordinate))
  // 清除配置项中为空的属性
  if (opts) {
    deleteEmptyKey(opts)
  }
  return new BMapGL.Polygon(points, opts)
}
